module.exports = __webpack_public_path__ + "static/media/10_disable_Unable_to_move.c69040df.svg";